import React from 'react';
import LegalPage from './LegalPage';

const sections = [
  {
    heading: 'Use of This Website',
    body: 'This website is provided for informational purposes and to allow prospective clients to request notary services from Pronto Notary. By using this site, you agree to provide accurate information when contacting us or requesting an appointment.'
  },
  {
    heading: 'Not Legal Advice',
    body: 'Pronto Notary is not a law firm, and nothing on this website constitutes legal advice. Carlos M Dasilva is a commissioned notary public in the State of Maryland. Notarial acts are governed by Maryland law. For legal advice regarding your documents, please consult a licensed attorney.'
  },
  {
    heading: 'Appointments and Fees',
    body: 'Appointment requests submitted through this website are not confirmed until you receive direct confirmation from us by phone, text, or email. Fees for notarial acts follow the maximums set by Maryland law under COMAR 01.02.08.02. Apostille service fees are flat-rate and disclosed on our Apostille page. Additional fees may apply for travel outside our standard service area.'
  },
  {
    heading: 'Cancellations',
    body: 'We ask that you notify us as soon as possible if you need to cancel or reschedule an appointment. Repeated last-minute cancellations may affect our ability to offer future same-day appointments.'
  },
  {
    heading: 'Limitation of Liability',
    body: 'While we take care to perform every notarization accurately and in accordance with Maryland law, Pronto Notary is not responsible for the legal validity, enforceability, or consequences of the documents you ask us to notarize. It is your responsibility to ensure your documents are complete and accurate before your appointment.'
  },
  {
    heading: 'Changes to These Terms',
    body: 'We may update these Terms of Service from time to time. Continued use of this website after changes are posted constitutes acceptance of the updated terms.'
  },
  {
    heading: 'Contact Us',
    body: 'Questions about these terms can be directed to [business email] or (240) 571-3117.'
  }
];

const TermsOfServicePage = () => (
  <LegalPage
    title="Terms of Service | Pronto Notary"
    description="Review the Pronto Notary Terms of Service, including website use, appointments, fees, cancellations, and limitations of liability."
    sections={sections}
  />
);

export default TermsOfServicePage;